import axios, { type AxiosInstance } from "axios";

import { ensureConfig } from "./config";

let axiosInstance: AxiosInstance | null = null;

export const getAxiosInstance = (): AxiosInstance => {
  const { baseURL, timeoutMs } = ensureConfig();

  if (!axiosInstance) {
    axiosInstance = axios.create({
      baseURL,
      timeout: timeoutMs ?? 15000,
      headers: { Accept: "application/json" },
    });
    return axiosInstance;
  }

  axiosInstance.defaults.baseURL = baseURL;
  axiosInstance.defaults.timeout = timeoutMs ?? 15000;

  return axiosInstance;
};
